import { auxiliaryStorage } from "./auxiliaryStorage";
import { useEffect, useState } from "react";
import { audioBus } from "./audio";

export function PortfolioThemeControl() {
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(() => auxiliaryStorage.getItem("hs-mute") === "on");
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onReducedMotionChange = () => {
      setReducedMotion(preference.matches);
      if (preference.matches) {
        audioBus.suspend();
        setPlaying(false);
      }
    };
    onReducedMotionChange();
    if (typeof preference.addEventListener === "function") preference.addEventListener("change", onReducedMotionChange);
    else if (typeof preference.addListener === "function") preference.addListener(onReducedMotionChange);
    return () => {
      audioBus.suspend();
      if (typeof preference.removeEventListener === "function") preference.removeEventListener("change", onReducedMotionChange);
      else if (typeof preference.removeListener === "function") preference.removeListener(onReducedMotionChange);
    };
  }, []);

  const togglePlay = () => {
    if (reducedMotion || muted) return;
    if (playing) {
      audioBus.suspend();
      setPlaying(false);
      return;
    }
    audioBus.unlock();
    setPlaying(audioBus.setBgm("lobby") || audioBus.resume());
  };

  const toggleMute = () => {
    const next = !muted;
    audioBus.setMuted(next);
    setMuted(next);
    if (next) setPlaying(false);
  };

  const status = reducedMotion
    ? "동작 줄이기 설정으로 음악이 꺼져 있어요."
    : muted ? "음소거" : playing ? "재생 중" : "음악 꺼짐";

  return (
    <aside className="portfolio-theme" aria-label="함께 쉬는 테마 듣기">
      <div>
        <span className="eyebrow">선택한 뒤 잠깐 듣기</span>
        <strong>함께 쉬는 테마</strong>
        <small role="status">{status}</small>
      </div>
      <div className="portfolio-theme__actions">
        <button type="button" disabled={reducedMotion || muted} onClick={togglePlay}>{playing ? "일시정지" : "재생"}</button>
        <button type="button" disabled={reducedMotion} onClick={toggleMute}>{muted ? "소리 켜기" : "음소거"}</button>
      </div>
    </aside>
  );
}
